import { postDataWithParams } from 'src/consumer/services/profileService'
import { postTimerData } from './TimerComponent/utils'

async function submitExistingTimer(
  objectToSubmit,
  src,
  srcId,
  afterSubmitFunction,
  contextData = {},
) {
  const response = await postTimerData(objectToSubmit, src, srcId)
  if (response.status === 200) {
    await afterSubmitFunction()
  }
}

async function submitAnonymousTimer(
  objectToSubmit,
  src,
  srcId,
  afterSubmitFunction,
  contextData = {},
) {
  const duration = objectToSubmit?.meditationDuration

  const response = await postDataWithParams(
    `/api/secure/add/user/anonyms/meditations/duration/${duration}`,
    {},
    {
      targetDuration: contextData?.duration || 0,
      clientSessionId: objectToSubmit.clientSessionId,
      clientCreatedTime: objectToSubmit.clientCreatedTime,
    },
  )
  if (response.status === 200) {
    await afterSubmitFunction()
  }
}

export async function submitPracticeTimer(
  submitObject,
  src,
  srcId,
  afterSubmitFunction = () => {},
  contextData = {},
) {
  if (!submitObject?.meditationId) {
    await submitAnonymousTimer(submitObject, src, srcId, afterSubmitFunction, contextData)
  }
  await submitExistingTimer(submitObject, src, srcId, afterSubmitFunction, contextData)
}
